class ExpressDeliveryAlertController {
    constructor(settings) {
        this.settings = settings;
    }

    closeAlert() {
        this.closed = true;
    }
}

ExpressDeliveryAlertController.$inject = ['Settings'];

const expressDeliveryAlertControllerDefinition = {
    controller: ExpressDeliveryAlertController,
    template: require('./express-delivery-alert.component.html').trim(),
};

module.exports = {
    ExpressDeliveryAlertController,
    expressDeliveryAlertControllerDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/delivery/express-delivery-alert.component.js